import { useMutation } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { generateReport } from '../../requests/generateReport';

type GenerateReportArgs = {
  type: string;
  params?: RequestConfig['params'];
};

export const useGenerateReport = () => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<void, Error, GenerateReportArgs>(
    {
      mutationFn: async ({ type, params }) =>
        generateReport(constructGet, type, params).then(() => undefined),
    },
  );

  return { generateReport: mutateAsync, ...rest };
};
